import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import BuildIcon from "@mui/icons-material/Build";
import ListAltIcon from "@mui/icons-material/ListAlt";

import styles from "./SeoServices.module.scss";

export default function SectionTeams({ ...rest }) {
  return (
    <div className="cd-section" {...rest}>
      {/* B2B Clients Start */}
      <div className="clients">
        <div className={styles.container} style={{ padding: "0.3rem" }}>
          <Card style={{ marginTop: "0.75rem", marginBottom: "0.75rem" }}>
            <GridContainer alignItems="center" style={{ margin: "0px" }}>
              <GridItem
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{ padding: "0.3rem", textAlign: "center", alignItems: "center" }}
              >
                <PhoneIcon style={{ color: "#e91e63", fontSize: "3rem" }} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style={{ padding: "0.3rem" }}>
                <CardContent style={{ padding: "0rem" }}>
                  <Typography gutterBottom component="h6">
                    1. Get in contact - phone/email
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    We will contact you, topline understand what business you are and discuss very high level work and costs
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{ marginTop: "0.75rem", marginBottom: "0.75rem" }}>
            <GridContainer alignItems="center" style={{ margin: "0px" }}>
              <GridItem
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{ padding: "0.3rem", textAlign: "center", alignItems: "center" }}
              >
                <BusinessIcon style={{ color: "#e91e63", fontSize: "3rem" }} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style={{ padding: "0.3rem" }}>
                <CardContent style={{ padding: "0rem" }}>
                  <Typography gutterBottom component="h6">
                    2. Assess your business Situation
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    We can begin generating a proposal in a few hours! We may need access to Google Analytics & similar platforms.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{ marginTop: "0.75rem", marginBottom: "0.75rem" }}>
            <GridContainer alignItems="center" style={{ margin: "0px" }}>
              <GridItem
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{ padding: "0.3rem", textAlign: "center", alignItems: "center" }}
              >
                <PriorityHighIcon style={{ color: "#e91e63", fontSize: "3rem" }} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style={{ padding: "0.3rem" }}>
                <CardContent style={{ padding: "0rem" }}>
                  <Typography gutterBottom component="h6">
                    3. We'll recommend priorities
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    We'll send you a "to the point" proposal and schedule a call where necessary. Work is either project or retainer based.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{ marginTop: "0.75rem", marginBottom: "0.75rem" }}>
            <GridContainer alignItems="center" style={{ margin: "0px" }}>
              <GridItem
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{ padding: "0.3rem", textAlign: "center", alignItems: "center" }}
              >
                <BuildIcon style={{ color: "#e91e63", fontSize: "3rem" }} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style={{ padding: "0.3rem" }}>
                <CardContent style={{ padding: "0rem" }}>
                  <Typography gutterBottom component="h6">
                    4. Implementation
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    We'll need access to your site. We'll establish quick comms via Slack, Trello and similar channels during this period.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{ marginTop: "0.75rem", marginBottom: "0.75rem" }}>
            <GridContainer alignItems="center" style={{ margin: "0px" }}>
              <GridItem
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{ padding: "0.3rem", textAlign: "center", alignItems: "center" }}
              >
                <ListAltIcon style={{ color: "#e91e63", fontSize: "3rem" }} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style={{ padding: "0.3rem" }}>
                <CardContent style={{ padding: "0rem" }}>
                  <Typography gutterBottom component="h6">
                    5. Results
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    We'll have a review meeting (or a regular meeting for retainer projects) and tidy everything off.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>
        </div>

        <br />
        {/* B2B Clients END */}
      </div>
    </div>
  );
}

